import React from 'react'

export default function Video() {
  return (
    <div className='video-container my-4'>
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/lhlf4qPwgLE" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    </div>
  )
}
